import React from 'react';
import Contact from './screens/contactus/contact.js';
import Footer from './screens/footer/footer.js';
import HomeScreen from './screens/homeScreen/HomeScreen.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Portfolio from './screens/Portfolio/portfolio.js';
import { ToastContainer } from 'react-toastify';
import NailArt from './screens/nailArt/nailArt.js';
import Academy from './screens/academy/academy.js';
import Aboutus from './screens/about-us/aboutus.js';
import Studio from './screens/studio/studio.js';
// import Login from './screens/report/auth/Login.js';

function App() {
  return (
    <div>
      <Router>
      {/* <Navbar /> */}
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/nail-art" element={<NailArt />} />
        <Route path="/academy" element={<Academy />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/studio" element={<Studio />} />
        {/* <Route path="/report/login" element={<Login />} /> */}
        {/* Add more routes as needed  */}
      </Routes>
      <Footer />
      <ToastContainer position="top-right" autoClose={2000} />
    </Router>
    </div>
  );
}

export default App;


// import React from 'react';
// import Contact from './screens/contactus/contact.js';
// import Footer from './screens/footer/footer.js';
// import HomeScreen from './screens/homeScreen/HomeScreen.js';
// import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// import Portfolio from './screens/Portfolio/portfolio.js';
// import { ToastContainer } from 'react-toastify';
// import NailArt from './screens/nailArt/nailArt.js';
// import Academy from './screens/academy/academy.js';
// import Aboutus from './screens/about-us/aboutus.js';
// import Studio from './screens/studio/studio.js';
// import Login from './screens/report/auth/Login.js';
// import Dashboard from './screens/report/dashboard/dashboard.js';
// import ProtectedRoute from './route/ProtectedRoute.js';
// import PublicRoute from './route/PublicRoute.js';
// import Employees from './screens/report/dashboardPages/manage-emp/employees.js';
// import Attendance from './screens/report/dashboardPages/mark-attendance/attendance.js';
// import ManageAttendance from './screens/report/dashboardPages/manage-attendance/manageAttendance.js';
// import Expenses from './screens/report/dashboardPages/expenses/expenses.js';
// import Revenue from './screens/report/dashboardPages/revenue/revenue.js';
// import Report from './screens/report/dashboardPages/report/report.js';
// import { Navigate } from 'react-router-dom';

// function Layout() {
//   const location = useLocation();

//   const hideFooterRoutes = ['/report/login', '/report/dashboard', '/report/employees', '/report/mark-attendance', '/report/attendance', '/report/expenses', '/report/revenue', '/report/report'];
//   const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

//   return (
//     <>
//       <Routes>
//         <Route path="/" element={<HomeScreen />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/portfolio" element={<Portfolio />} />
//         <Route path="/nail-art" element={<NailArt />} />
//         <Route path="/academy" element={<Academy />} />
//         <Route path="/about-us" element={<Aboutus />} />
//         <Route path="/studio" element={<Studio />} />

//         {/* ✅ LOGIN (blocked if logged in) */}
//         {/* <Route
//           path="/report/login"
//           element={
//             <PublicRoute>
//               <Login />
//             </PublicRoute>
//           }
//         /> */}

//         {/* ✅ DASHBOARD (protected) */}
//         <Route
//           path="/report/dashboard"
//           element={
//             <ProtectedRoute>
//               <Dashboard />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//   path="/report/employees"
//   element={
//     <ProtectedRoute>
//       <Employees />
//     </ProtectedRoute>
//   }
// />

// <Route
//   path="/report/mark-attendance"
//   element={
//     <ProtectedRoute>
//       <Attendance />
//     </ProtectedRoute>
//   }
// />

// <Route
//   path="/report/attendance"
//   element={
//     <ProtectedRoute>
//       <ManageAttendance />
//     </ProtectedRoute>
//   }
// />

// <Route
//   path="/report/expenses"
//   element={
//     <ProtectedRoute>
//       <Expenses />
//     </ProtectedRoute>
//   }
// />

// <Route
//   path="/report/revenue"
//   element={
//     <ProtectedRoute>
//       <Revenue />
//     </ProtectedRoute>
//   }
// />
// <Route
//   path="/report/report"
//   element={
//     <ProtectedRoute>
//       <Report />
//     </ProtectedRoute>
//   }
// />
//   <Route path="*" element={<Navigate to="/" replace />} />

//       </Routes>

//       {!shouldHideFooter && <Footer />}
//       <ToastContainer position="top-right" autoClose={2000} />
//     </>
//   );
// }

// function App() {
//   return (
//     <Router>
//       <Layout />
//     </Router>
//   );
// }

// export default App;